module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 row mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]) + ": " + _vm._s(_vm.uname))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][30]))])])], 1)]), _vm._v(" "), _c('strong', [_c('div', {
    class: _vm.alertObject
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2])), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v(" " + _vm._s(_vm.msglist[_vm.$route.params.language][3]))])]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_new),
      expression: "email_new"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email_new)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email_new = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.applyChange
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))]), _vm._v(" "), (_vm.uname === 'default') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.delMail
    }
  }, [_vm._v("Del")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][4]))]), _vm._v(" "), _c('div', {
    staticClass: "row px-0 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][5]) + " \r\n                  "), _c('div', {
    staticClass: "col px-2 mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPassword),
      expression: "currentPassword"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row px-0 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]) + "\r\n                  "), _c('div', {
    staticClass: "col px-2  mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row px-0 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]) + "\r\n                  "), _c('div', {
    staticClass: "col px-2  mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.applyChange
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col px-3 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][11]))]), _vm._v(" "), _c('div', {
    staticClass: "row px-3 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][31]) + " \r\n            "), _c('div', {
    staticClass: "col px-2 mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSerial),
      expression: "newSerial"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newSerial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSerial = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row px-3 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][32]) + "\r\n            "), _c('div', {
    staticClass: "col px-2  mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassCode),
      expression: "newPassCode"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPassCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row px-3 mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][33]) + "\r\n            "), _c('div', {
    staticClass: "col px-2  mx-0 mb-2 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDevname),
      expression: "newDevname"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "20",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newDevname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDevname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addDevice
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][12]))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.updDevname
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][34]))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.delDevice
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][21]))]), _vm._v(" "), (_vm.uname === 'default') ? _c('div', {
    staticClass: "col-12 px-0 mt-2 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.resetPcode
    }
  }, [_vm._v("Pcd")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.resetDevice
    }
  }, [_vm._v("Rst")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.insertDevice
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.delDbDevice
    }
  }, [_vm._v("Del")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col mx-0 px-0 py-2 mb-1 text-center",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'entry',
        params: {
          language: 'en'
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px"
    },
    on: {
      "click": _vm.loggingOut
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][10]))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px"
    },
    on: {
      "click": _vm.delAcount
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][19]))])], 1), _vm._v(" "), (_vm.uname === 'default') ? _c('div', {
    staticClass: "col mx-0 px-3 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("增刪改多個設備資料庫")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mb-2 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.resetPcode_G
    }
  }, [_vm._v("Pcd")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.update_ver_G
    }
  }, [_vm._v("Upd")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.resetDevice_G
    }
  }, [_vm._v("Rst")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.insertDevice_G
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.delDbDevice_G
    }
  }, [_vm._v("Del")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSerial_G),
      expression: "newSerial_G"
    }],
    staticClass: "col mx-0 px-1 form-control",
    attrs: {
      "rows": "10",
      "placeholder": "序號(tab)啟動碼(tab)版本(\\n)\r\nKH1-00-00001 abcd 40117\r\n\r\nPcd - 重設KHA密碼\r\nUpd - 更新KHA韌體版本\r\nRst - 重設網站設定 清除數據\r\nAdd - 新增KHA到資料庫\r\nDel - 從資料庫刪除KHA "
    },
    domProps: {
      "value": (_vm.newSerial_G)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSerial_G = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.uname === '123') ? _c('div', {
    staticClass: "col mx-0 px-3 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("修改設備資料庫")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mb-2 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.resetPcode_G
    }
  }, [_vm._v("Pcd")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background-color": "#ffc105",
      "border": "none"
    },
    attrs: {
      "disable": _vm.disabled
    },
    on: {
      "click": _vm.update_ver_G
    }
  }, [_vm._v("Upd")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSerial_G),
      expression: "newSerial_G"
    }],
    staticClass: "col mx-0 px-1 form-control",
    attrs: {
      "rows": "10",
      "placeholder": "序號(tab)啟動碼(tab)版本(\\n)\r\nKH1-00-00001 abcd 40117\r\n\r\nPcd - 重設KHA密碼\r\nUpd - 更新KHA韌體版本\r\n"
    },
    domProps: {
      "value": (_vm.newSerial_G)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSerial_G = $event.target.value
      }
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6ca32b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 538
// module chunks = 0